import { render, staticRenderFns } from "./checkFangxinAuthentication.vue?vue&type=template&id=26d69ae8&scoped=true&"
import script from "./checkFangxinAuthentication.vue?vue&type=script&lang=js&"
export * from "./checkFangxinAuthentication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d69ae8",
  null
  
)

export default component.exports